import React, {useContext} from 'react';

import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Colors from '../../../helpers/Colors';
import Text from '../Text';
import {AppContext} from "../../../contexts/AppContext";

function TableHeader({ type }) {
  const classes = useStyles();
  const { isAssignerMode } = useContext(AppContext);

  return (
    <Box>
      {/* {headerItems.map((header_item, index) => (
          <Box key={header_item} className={index === 0 ? classes.headerIndexItemContainer : classes.headerItemContainer}>
            <Text
              className={
                index === 0 ?
                  classes.headerFirstLabel
                  :
                  classes.headerLabel
              }
            >
              {header_item}
            </Text>
          </Box>
        ))} */}

      {type === 'pickup' &&
        <Box className={classes.headerContainer}>

          <Box className={classes.headerIndexItemContainer} style={{ flex: 1.8 }}>
            <Text
              className={classes.headerFirstLabel}
            >
              ORDER ID
          </Text>
          </Box>
          <Box className={classes.headerItemContainer} style={{ flex: 1 }}>
            <Text
              className={classes.headerLabel}
            >
              BRAND
          </Text>
          </Box>
          <Box className={classes.headerItemContainer} style={{ flex: 1 }}>
            <Text
              className={classes.headerLabel}
            >
              CHANNEL
          </Text>
          </Box>
          <Box className={classes.headerItemContainer} style={{ flex: 1 }}>
            <Text
              className={classes.headerLabel}
            >
              DELIVERY MODE
          </Text>
          </Box>
          <Box className={classes.headerItemContainer} style={{ flex: 1 }}>
            <Text
              className={classes.headerLabel}
            >
              TIMER
          </Text>
          </Box>
          <Box className={classes.headerItemContainer} style={{ flex: 9.5 }}>
            <Text
              className={classes.headerLabel}
            >
              STATUS
          </Text>
          </Box>
        </Box>}

      {type !== 'pickup' &&
        <Box className={classes.headerContainer}>
          <Box className={classes.headerIndexItemContainer} style={{ flex: 1.8 }}>
            <Text
              className={classes.headerFirstLabel}
            >
              ORDER ID
          </Text>
          </Box>
          <Box className={classes.headerItemContainer} style={{ flex: 1 }}>
            <Text
              className={classes.headerLabel}
            >
              BRAND
          </Text>
          </Box>
          <Box className={classes.headerItemContainer} style={{ flex: 1 }}>
            <Text
              className={classes.headerLabel}
            >
              CHANNEL
          </Text>
          </Box>
          <Box className={classes.headerItemContainer} style={{ flex: 1 }}>
            <Text
              className={classes.headerLabel}
            >
              DELIVERY MODE
          </Text>
          </Box>
          <Box className={classes.headerItemContainer} style={{ flex: 1 }}>
            <Text
              className={classes.headerLabel}
            >
              TIMER
          </Text>
          </Box>
          {isAssignerMode ? (<Box className={classes.headerItemContainer} style={{flex: 1}}>
            <Text
                className={classes.headerLabel}
            >
              CUBBY
            </Text>
          </Box>) : null}
          <Box className={classes.headerItemContainer} style={{ flex: 9.5}}>
            <Text
              className={classes.headerLabel}
            >
              STATUS
          </Text>
          </Box>
        </Box>}
      <Box className={classes.headerBlankView} />
    </Box>
  );
}


const useStyles = makeStyles((theme) => ({
  headerFirstLabel: {
    color: Colors.grayLabel,
    opacity: 0.6,
    fontSize: 12,
    fontWeight: '600',
    paddingLeft: 20,
    fontFamily: 'DINNextLTPro-Regular',
  },
  headerLabel: {
    color: Colors.grayLabel,
    opacity: 0.6,
    fontSize: 12,
    fontWeight: '600',
    fontFamily: 'DINNextLTPro-Regular',
  },
  headerContainer: {
    display: 'flex',
    flex: 1,
    direction: 'row',
    height: 50,
  },
  headerIndexItemContainer: {
    display: 'flex',
    flex: 1.4,
    height: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  headerItemContainer: {
    display: 'flex',
    flex: 1,
    height: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  headerBlankView: {
    display: 'flex',
    flex: 6,
  }
}));

export default TableHeader;